import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history?${p}`);
  },
  exportToExcel(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history?${p}`, {
      responseType: "blob",
    });
  },
  create(data) {
    return api.post(`/api/v1/call-customer-history`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/call-customer-history/${id}`, data);
  },
  calRresult() {
    return api.get(`/api/v1/call-result`);
  },
  getCustomers(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history/customer?${p}`);
  },
  reAttempt(data) {
    return api.post(`/api/v1/call-customer-history/re-attempt`, data);
  },
  getCustomerRenewal(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history/customer-renewal?${p}`);
  },
  getTasks(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history/tasks?${p}`);
  },
  getCalls(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history/calls?${p}`);
  },
  getUsers(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/call-customer-history/users?${p}`);
  },
  lock(id) {
    return api.put(`/api/v1/call-customer-history/lock/${id}`);
  },
  getCustomerById(id) {
    return api.get(`/api/v1/call-customer-history/customer-by-id/${id}`);
  },
};

